(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-cta"] && !Shopify.designMode) return;
  try {
    (() => {
    const containers =
      '[data-trial-pack], [data-single-product-container-v2], [data-single-product-container], [data-promo-subscription-builder], [data-single-bundle-container], [data-bundles-container-v2], [data-bundles-container]';
    const instances = new Map();
    let cardScript;
    class StickyProductController {
      constructor(root) {
        this.elements = this.getElements(root);
        this.state = {
          isTriggerVisible: true,
          isFooterIntersecting: false,
        };

        this.init();
      }

      getElements(stickyProduct) {
        const owner = stickyProduct.closest(containers);
        const stickyButton = stickyProduct.querySelector('[data-sticky-cta-button], [data-sticky-card-button]');
        if (!owner || !stickyButton) return;
        return {
          stickyProduct,
          stickyButton,
          owner,
          triggerElement: owner.querySelector('[data-sticky-trigger]'),
          scrollTarget: owner.querySelector('[data-sticky-scroll-target]'),
          footerElement: document.querySelector('footer'),
          isSingleProduct: stickyButton.dataset.singleProduct === 'true',
          position: stickyProduct.dataset.stickyPosition || 'top',
        };
      }

      init() {
        if (!this.elements) {
          return;
        }

        this.setupObservers();
        this.setupEventListeners();
        this.setupResizeHandling();
        this.updateVisibility();
      }

      setupObservers() {
        if (this.elements.triggerElement) {
          this.triggerObserver = new IntersectionObserver(this.handleTriggerIntersection.bind(this), {
            threshold: 0,
            rootMargin: '0px',
          });

          this.triggerObserver.observe(this.elements.triggerElement);
        }

        // Observer for footer visibility
        if (this.elements.footerElement) {
          this.footerObserver = new IntersectionObserver(this.handleFooterIntersection.bind(this), {
            threshold: 0,
            rootMargin: '0px 0px -100px 0px',
          });

          this.footerObserver.observe(this.elements.footerElement);
        }
      }

      handleTriggerIntersection(entries) {
        const entry = entries[0];
        // Trigger has been scrolled past only when it's above the viewport.
        // Using boundingClientRect avoids relying on offsetTop, which is
        // relative to the nearest positioned ancestor (e.g. a sticky parent)
        // and would return ~0, making the check fire prematurely.
        const hasScrolledPastTrigger = !entry.isIntersecting && entry.boundingClientRect.top < 0;

        this.updateState({
          isTriggerVisible: !hasScrolledPastTrigger,
        });
      }

      handleFooterIntersection(entries) {
        const entry = entries[0];
        this.updateState({
          isFooterIntersecting: entry.isIntersecting,
        });
      }

      updateState(newState) {
        this.state = { ...this.state, ...newState };
        this.updateVisibility();
      }

      updateVisibility() {
        const shouldShow = !this.state.isTriggerVisible && !this.state.isFooterIntersecting;
        this.elements.stickyProduct.classList.toggle('show', shouldShow);
        this.updateTopOffset();
      }

      setupResizeHandling() {
        if (this.elements.position !== 'top') {
          return;
        }

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.updateTopOffset.bind(this));
          this.resizeObserver.observe(this.elements.stickyProduct);
        }

        this.onResize = this.updateTopOffset.bind(this);
        window.addEventListener('resize', this.onResize);
      }

      updateTopOffset() {
        const visibleTopStickyProducts = Array.from(document.querySelectorAll('.sticky-product--top.show'));

        if (visibleTopStickyProducts.length === 0) {
          document.body.classList.remove('sticky-cta-top-visible');
          document.documentElement.style.removeProperty('--sticky-cta-height');
          return;
        }

        const stickyHeight = Math.max(
          ...visibleTopStickyProducts.map(
            (stickyProduct) => stickyProduct.getBoundingClientRect().height || stickyProduct.offsetHeight,
          ),
        );

        document.documentElement.style.setProperty('--sticky-cta-height', `${stickyHeight}px`);
        document.body.classList.add('sticky-cta-top-visible');
      }

      setupEventListeners() {
        if (this.elements.stickyProduct.dataset.stickyStyle === 'card') return;
        this.onClick = this.handleButtonClick.bind(this);
        this.elements.stickyButton.addEventListener('click', this.onClick);
      }

      destroy() {
        this.triggerObserver?.disconnect?.();
        this.footerObserver?.disconnect?.();
        this.resizeObserver?.disconnect?.();
        window.removeEventListener('resize', this.onResize);
        this.elements?.stickyButton.removeEventListener('click', this.onClick);
        this.elements?.stickyProduct.classList.remove('show');
        this.updateTopOffset();
      }

      handleButtonClick() {
        if (this.elements.isSingleProduct) {
          return this.handleSingleProductClick();
        }

        const isDisabled = this.elements.stickyButton.dataset.disabled === 'true';
        return isDisabled ? this.handleScrollToTarget() : this.handleBundleClick();
      }

      handleSingleProductClick() {
        const addButton = this.elements.owner.querySelector('[data-add-to-cart]');
        if (!addButton) {
          return;
        }

        addButton.click();
      }

      handleScrollToTarget() {
        if (!this.elements.scrollTarget) {
          return;
        }

        this.elements.scrollTarget.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }

      handleBundleClick() {
        const bundlesContainer = this.elements.owner;
        const activeBundleId = bundlesContainer.dataset.activeBundle;
        const addButton = bundlesContainer.querySelector(
          `[data-add-to-cart][data-active-on-bundle="${activeBundleId}"]`,
        );

        if (!addButton) {
          return;
        }

        addButton.click();
      }
    }

    function init() {
      instances.forEach((controller, root) => {
        if (!root.isConnected) {
          controller.destroy();
          instances.delete(root);
        }
      });
      document.querySelectorAll('.sticky-product').forEach((root) => {
        if (!instances.has(root)) instances.set(root, new StickyProductController(root));
        if (root.dataset.cardControllerUrl && !customElements.get('sticky-cta-card') && !cardScript) {
          cardScript = document.createElement('script');
          cardScript.src = root.dataset.cardControllerUrl;
          cardScript.onerror = () => {
            cardScript.remove();
            cardScript = null;
          };
          document.head.appendChild(cardScript);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', (event) => {
      instances.forEach((controller, root) => {
        if (event.target.contains(root)) {
          controller.destroy();
          instances.delete(root);
        }
      });
    });
    if (document.readyState !== 'loading') init();
  })();
  } catch(e) { console.error(e); }
})();

})();
